import { Box } from '@mui/material'
import * as React from 'react'
import { type SVGProps } from 'react'

export function AwardIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#fff'

  return (
    <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2105_107077)">
        <path
          d="M4.76 10.004v4.479l3.048-1.22c.071-.028.107-.043.144-.048a.324.324 0 0 1 .098 0c.037.005.072.02.143.048l3.049 1.22v-4.479m1.62-3.623a4.861 4.861 0 1 1-9.722 0 4.861 4.861 0 0 1 9.722 0Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.296}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M.223.223h15.556v15.556H.223z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function LineChart(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2105_107060)">
        <path
          d="M11.889 6.705 9.663 8.93c-.128.128-.193.192-.267.216a.324.324 0 0 1-.2 0c-.074-.024-.138-.088-.266-.216L7.07 7.07c-.128-.128-.192-.192-.266-.216a.324.324 0 0 0-.2 0c-.074.024-.139.088-.267.216L4.111 9.297m10.37-1.296a6.481 6.481 0 1 1-12.962 0 6.481 6.481 0 0 1 12.963 0Z"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.296}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M.223.223h15.556v15.556H.223z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ClipboardIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#fff'

  return (
    <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2105_107081)">
        <path
          d="M10.593 2.816c.603 0 .904 0 1.152.066.67.18 1.195.704 1.375 1.375.066.247.066.549.066 1.151v5.963c0 1.09 0 1.634-.212 2.05a1.945 1.945 0 0 1-.85.85c-.416.211-.96.211-2.05.211H5.928c-1.09 0-1.634 0-2.05-.211a1.945 1.945 0 0 1-.85-.85c-.212-.416-.212-.96-.212-2.05V5.408c0-.602 0-.904.067-1.151a1.944 1.944 0 0 1 1.375-1.375c.247-.066.548-.066 1.151-.066m.648 7.13 1.296 1.296 2.917-2.917M6.445 4.112h3.111c.363 0 .545 0 .683-.07a.648.648 0 0 0 .284-.284c.07-.138.07-.32.07-.683v-.518c0-.363 0-.545-.07-.684a.648.648 0 0 0-.284-.283c-.138-.07-.32-.07-.683-.07h-3.11c-.364 0-.545 0-.684.07a.648.648 0 0 0-.283.283c-.071.14-.071.32-.071.684v.518c0 .363 0 .545.07.683a.648.648 0 0 0 .284.283c.139.071.32.071.683.071Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.296}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M.223.223h15.556v15.556H.223z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function HandIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2105_107442)">
        <path
          d="M4.695 7.64v1.801m0-1.8V3.32c0-.597.493-1.08 1.102-1.08.608 0 1.102.483 1.102 1.08M4.695 7.64c0-.596-.493-1.08-1.102-1.08-.608 0-1.102.484-1.102 1.08v1.441c0 2.983 2.467 5.402 5.51 5.402 3.042 0 5.509-2.419 5.509-5.402v-3.6c0-.597-.494-1.08-1.102-1.08-.609 0-1.102.483-1.102 1.08M6.899 3.32v3.96m0-3.96V2.6c0-.597.493-1.08 1.101-1.08.609 0 1.102.483 1.102 1.08v.72m0 0v3.96m0-3.96c0-.597.494-1.08 1.102-1.08.609 0 1.102.483 1.102 1.08v2.16m0 0v1.8"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.296}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M.223.223h15.556v15.556H.223z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function ThunderIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height={16} width={14} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M7.649 1.52 1.876 8.447c-.226.271-.34.407-.34.521-.002.1.042.195.12.257.089.072.265.072.618.072h4.727l-.649 5.185 5.773-6.927c.226-.271.34-.407.341-.521a.324.324 0 0 0-.12-.257c-.09-.072-.266-.072-.62-.072H7.002l.648-5.185Z"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.296}
      />
    </svg>
  )
}

export function MultiSelectIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2105_108366)">
        <path
          d="m4.111 9.945 1.296 1.297 2.917-2.917M5.407 5.408V3.594c0-.726 0-1.09.142-1.367.124-.244.322-.442.566-.566.278-.141.64-.141 1.367-.141h4.925c.726 0 1.09 0 1.367.14.244.125.442.323.566.567.142.278.142.64.142 1.367V8.52c0 .726 0 1.089-.142 1.366a1.296 1.296 0 0 1-.566.566c-.278.142-.64.142-1.367.142h-1.814m-7 3.889h4.926c.726 0 1.089 0 1.366-.142.244-.124.442-.322.566-.566.142-.278.142-.64.142-1.367V7.482c0-.726 0-1.088-.142-1.366a1.296 1.296 0 0 0-.566-.566c-.277-.142-.64-.142-1.366-.142H3.593c-.726 0-1.09 0-1.367.142a1.296 1.296 0 0 0-.566.566c-.141.278-.141.64-.141 1.366v4.926c0 .726 0 1.09.14 1.367.125.244.323.442.567.566.278.142.64.142 1.367.142Z"
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.296}
        />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M.223.223h15.556v15.556H.223z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function SingleSelectIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="m5.084 8.001 1.944 1.945 3.889-3.89m-5.639 7.779h5.445c1.088 0 1.633 0 2.049-.212.366-.187.663-.484.85-.85.212-.416.212-.96.212-2.05V5.28c0-1.089 0-1.633-.212-2.05a1.945 1.945 0 0 0-.85-.85c-.416-.211-.96-.211-2.05-.211H5.279c-1.089 0-1.633 0-2.05.212a1.944 1.944 0 0 0-.85.85c-.211.416-.211.96-.211 2.05v5.443c0 1.09 0 1.634.212 2.05.186.366.484.663.85.85.416.212.96.212 2.05.212Z"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.296}
      />
    </svg>
  )
}

export function MicIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#98A2B3'

  return (
    <svg fill="none" height={25} viewBox="0 0 25 25" width={25} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M20.5 12.922v1a8 8 0 1 1-16 0v-1m8 5a4 4 0 0 1-4-4v-6a4 4 0 0 1 8 0v6a4 4 0 0 1-4 4Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      />
    </svg>
  )
}

export function BarChartIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#4E5BA6'

  return (
    <svg fill="none" height={12} viewBox="0 0 10 10" width={12} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2406_1846)">
        <path
          d="M3.667 5.363v1.455m2.91-2.182v2.182M5.121 3.18v3.637M8.758 5a3.636 3.636 0 1 1-7.273 0 3.636 3.636 0 0 1 7.273 0Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M.758.637h8.727v8.727H.758z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function AnnotationInfoIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#4E5BA6'

  return (
    <svg fill="none" height={12} viewBox="0 0 10 10" width={12} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2406_7631)">
        <path
          d="M4.819 5.727V4.454m0-1.273h.003m-.767 4.436.53.708c.08.106.12.158.168.177.042.017.09.017.132 0 .048-.019.087-.071.166-.177l.531-.708c.107-.142.16-.213.225-.267a.727.727 0 0 1 .3-.15c.081-.019.17-.019.348-.019.508 0 .762 0 .963-.083.267-.11.48-.323.59-.59.083-.2.083-.455.083-.963V3.472c0-.61 0-.916-.119-1.15a1.09 1.09 0 0 0-.476-.477c-.234-.118-.54-.118-1.15-.118H3.29c-.61 0-.916 0-1.15.118a1.09 1.09 0 0 0-.476.477c-.12.234-.12.539-.12 1.15v2.073c0 .508 0 .762.084.963.11.267.323.48.59.59.2.083.455.083.963.083.178 0 .267 0 .35.02.11.026.211.077.298.149.065.054.118.125.225.267Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M.455.637h8.727v8.727H.455z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function FileIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height={12} viewBox="0 0 10 9" width={12} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2406_644)">
        <path
          d="M5.243 4.636H3.06m.727 1.455h-.727m2.91-2.91H3.06m4.364-.072V6.89c0 .61 0 .916-.12 1.15a1.09 1.09 0 0 1-.476.476c-.233.119-.539.119-1.15.119H3.352c-.611 0-.917 0-1.15-.119a1.09 1.09 0 0 1-.477-.477c-.119-.233-.119-.538-.119-1.15V3.11c0-.611 0-.917.12-1.15a1.09 1.09 0 0 1 .476-.477c.233-.119.539-.119 1.15-.119h2.327c.611 0 .917 0 1.15.12.205.104.372.27.477.476.119.233.119.539.119 1.15Z"
          stroke="#4E5BA6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M.151.637h8.727v8.727H.151z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function DeleteIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#98A2B3'

  return (
    <svg fill="none" height={17} width={17} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11.167 4.448v-.533c0-.747 0-1.12-.146-1.406a1.333 1.333 0 0 0-.582-.582c-.286-.146-.659-.146-1.406-.146H7.967c-.747 0-1.12 0-1.406.146-.25.127-.455.331-.582.582-.146.285-.146.659-.146 1.406v.533m1.334 3.667v3.333m2.666-3.333v3.333m-7.333-7h12m-1.333 0v7.467c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874c-.428.218-.988.218-2.108.218H7.033c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108V4.448"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.333}
      />
    </svg>
  )
}

export function SettingsIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.0337 6.75781H3.66667C2.74619 6.75781 2 6.01162 2 5.09115C2 4.17067 2.74619 3.42448 3.66667 3.42448H10.0337M5.96633 14.0911H12.3333C13.2538 14.0911 14 13.345 14 12.4245C14 11.504 13.2538 10.7578 12.3333 10.7578H5.96633M2 12.4245C2 13.7131 3.04467 14.7578 4.33333 14.7578C5.622 14.7578 6.66667 13.7131 6.66667 12.4245C6.66667 11.1358 5.622 10.0911 4.33333 10.0911C3.04467 10.0911 2 11.1358 2 12.4245ZM14 5.09115C14 6.37981 12.9553 7.42448 11.6667 7.42448C10.378 7.42448 9.33333 6.37981 9.33333 5.09115C9.33333 3.80248 10.378 2.75781 11.6667 2.75781C12.9553 2.75781 14 3.80248 14 5.09115Z"
        stroke="#344054"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.33333"
      />
    </svg>
  )
}

export function PlayCircle() {
  return (
    <svg fill="none" height="17" viewBox="0 0 16 17" width="16" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1914_60646)">
        <path
          d="M8.00016 14.7669C11.6821 14.7669 14.6668 11.7822 14.6668 8.10026C14.6668 4.41836 11.6821 1.43359 8.00016 1.43359C4.31826 1.43359 1.3335 4.41836 1.3335 8.10026C1.3335 11.7822 4.31826 14.7669 8.00016 14.7669Z"
          fill="#FDF2FA"
        />
        <path
          d="M6.3335 6.07715C6.3335 5.75896 6.3335 5.59986 6.39999 5.51105C6.45794 5.43364 6.54664 5.38522 6.64308 5.37833C6.75375 5.37042 6.88758 5.45646 7.15523 5.62852L10.3023 7.65163C10.5346 7.80094 10.6507 7.87559 10.6908 7.97052C10.7258 8.05346 10.7258 8.14706 10.6908 8.23C10.6507 8.32493 10.5346 8.39958 10.3023 8.54889L7.15523 10.572C6.88758 10.7441 6.75375 10.8301 6.64308 10.8222C6.54664 10.8153 6.45794 10.7669 6.39999 10.6895C6.3335 10.6007 6.3335 10.4416 6.3335 10.1234V6.07715Z"
          fill="#FDF2FA"
        />
        <path
          d="M8.00016 14.7669C11.6821 14.7669 14.6668 11.7822 14.6668 8.10026C14.6668 4.41836 11.6821 1.43359 8.00016 1.43359C4.31826 1.43359 1.3335 4.41836 1.3335 8.10026C1.3335 11.7822 4.31826 14.7669 8.00016 14.7669Z"
          stroke="#EE46BC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.3335 6.07715C6.3335 5.75896 6.3335 5.59986 6.39999 5.51105C6.45794 5.43364 6.54664 5.38522 6.64308 5.37833C6.75375 5.37042 6.88758 5.45646 7.15523 5.62852L10.3023 7.65163C10.5346 7.80094 10.6507 7.87559 10.6908 7.97052C10.7258 8.05346 10.7258 8.14706 10.6908 8.23C10.6507 8.32493 10.5346 8.39958 10.3023 8.54889L7.15523 10.572C6.88758 10.7441 6.75375 10.8301 6.64308 10.8222C6.54664 10.8153 6.45794 10.7669 6.39999 10.6895C6.3335 10.6007 6.3335 10.4416 6.3335 10.1234V6.07715Z"
          stroke="#EE46BC"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1914_60646">
          <rect fill="white" height="16" transform="translate(0 0.101562)" width="16" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function PencilIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#fff'

  return (
    <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.40283 15.3561L6.25649 13.8739C6.50298 13.7791 6.62622 13.7317 6.74153 13.6698C6.84394 13.6149 6.94158 13.5514 7.03342 13.4802C7.13681 13.3999 7.23018 13.3066 7.41692 13.1198L15.2501 5.28667C16.0171 4.51961 16.0171 3.27595 15.2501 2.50889C14.483 1.74183 13.2394 1.74183 12.4723 2.50889L4.63914 10.342C4.4524 10.5288 4.35903 10.6221 4.2788 10.7255C4.20754 10.8174 4.14408 10.915 4.08911 11.0174C4.02721 11.1327 3.97981 11.256 3.88501 11.5025L2.40283 15.3561ZM2.40283 15.3561L3.83208 11.6401C3.93436 11.3742 3.9855 11.2412 4.07321 11.1803C4.14986 11.1271 4.24471 11.107 4.33637 11.1245C4.44126 11.1445 4.54199 11.2453 4.74345 11.4467L6.31226 13.0155C6.51372 13.217 6.61445 13.3177 6.63447 13.4226C6.65198 13.5143 6.63185 13.6091 6.57863 13.6858C6.51773 13.7735 6.38477 13.8246 6.11885 13.9269L2.40283 15.3561Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.38889"
      />
    </svg>
  )
}

export function AnnotationIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9 10.3889V7.95833M9 5.52778H9.00695M7.54167 14L8.55556 15.3519C8.70633 15.5529 8.78172 15.6534 8.87414 15.6894C8.95509 15.7208 9.04491 15.7208 9.12586 15.6894C9.21828 15.6534 9.29367 15.5529 9.44445 15.3519L10.4583 14C10.6619 13.7286 10.7637 13.5929 10.8879 13.4892C11.0534 13.3511 11.2488 13.2534 11.4587 13.2038C11.6161 13.1667 11.7857 13.1667 12.125 13.1667C13.0957 13.1667 13.5811 13.1667 13.9639 13.0081C14.4744 12.7966 14.88 12.3911 15.0914 11.8806C15.25 11.4977 15.25 11.0124 15.25 10.0417V6.08333C15.25 4.91656 15.25 4.33317 15.0229 3.88752C14.8232 3.49552 14.5045 3.17681 14.1125 2.97707C13.6668 2.75 13.0834 2.75 11.9167 2.75H6.08333C4.91656 2.75 4.33317 2.75 3.88752 2.97707C3.49552 3.17681 3.17681 3.49552 2.97707 3.88752C2.75 4.33317 2.75 4.91656 2.75 6.08333V10.0417C2.75 11.0124 2.75 11.4977 2.90858 11.8806C3.12003 12.3911 3.5256 12.7966 4.03608 13.0081C4.41893 13.1667 4.90429 13.1667 5.875 13.1667C6.21429 13.1667 6.38394 13.1667 6.54132 13.2038C6.75117 13.2534 6.94661 13.3511 7.11215 13.4892C7.23631 13.5929 7.33809 13.7286 7.54167 14Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.38889"
      />
    </svg>
  )
}

export function UploadIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#3E4784'

  return (
    <svg fill="none" height={20} viewBox="0 0 20 20" width={20} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M6.666 13.333 9.999 10m0 0 3.334 3.333M9.999 10v7.5m6.667-3.548a4.583 4.583 0 0 0-2.917-8.12.52.52 0 0 1-.445-.25 6.25 6.25 0 1 0-9.816 7.58"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.667}
      />
    </svg>
  )
}

export function GeneralSettingsIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#4E5BA6'

  return (
    <svg fill="none" height={21} viewBox="0 0 21 21" width={21} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#a)" stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.667}>
        <path d="M10.091 12.587a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
        <path d="M15.697 12.36a1.25 1.25 0 0 0 .25 1.379l.046.045a1.515 1.515 0 0 1-1.072 2.588 1.5 1.5 0 0 1-1.072-.444l-.046-.045a1.25 1.25 0 0 0-1.379-.25 1.25 1.25 0 0 0-.757 1.144v.128a1.515 1.515 0 1 1-3.03 0v-.068a1.25 1.25 0 0 0-.819-1.144 1.25 1.25 0 0 0-1.378.25l-.046.046a1.515 1.515 0 1 1-2.144-2.144l.046-.046a1.25 1.25 0 0 0 .25-1.378 1.25 1.25 0 0 0-1.144-.758h-.129a1.515 1.515 0 1 1 0-3.03h.068a1.25 1.25 0 0 0 1.144-.818 1.25 1.25 0 0 0-.25-1.38L4.19 6.39a1.515 1.515 0 1 1 2.144-2.144l.045.046a1.25 1.25 0 0 0 1.379.25h.06a1.25 1.25 0 0 0 .758-1.144v-.129a1.515 1.515 0 0 1 3.03 0v.068a1.25 1.25 0 0 0 .758 1.144 1.25 1.25 0 0 0 1.379-.25l.045-.045a1.515 1.515 0 0 1 2.588 1.072 1.5 1.5 0 0 1-.444 1.072l-.045.045a1.25 1.25 0 0 0-.25 1.379v.06a1.25 1.25 0 0 0 1.143.758h.13a1.515 1.515 0 1 1 0 3.03h-.069a1.25 1.25 0 0 0-1.144.758" />
      </g>
      <defs>
        <clipPath id="a">
          <path d="M.092.086h20v20h-20z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function PreviewIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#4E5BA6'

  return (
    <svg fill="none" height={21} viewBox="0 0 21 21" width={21} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2.109 10.682c-.114-.18-.17-.27-.202-.409a1 1 0 0 1 0-.372c.031-.139.088-.228.202-.408.937-1.485 3.729-5.24 7.983-5.24s7.046 3.755 7.984 5.24c.113.18.17.27.202.408a1 1 0 0 1 0 .372c-.032.139-.089.229-.202.409-.938 1.484-3.73 5.239-7.984 5.239s-7.046-3.754-7.983-5.24"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.667}
      />
      <path
        d="M10.092 12.587a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
        stroke="#4E5BA6"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.667}
      />
    </svg>
  )
}

export function ShareIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#4E5BA6'

  return (
    <svg fill="none" height={21} viewBox="0 0 21 21" width={21} xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M17.592 10.086v3.5c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 0 1-1.092 1.093c-.535.272-1.235.272-2.635.272h-7c-1.4 0-2.1 0-2.635-.272a2.5 2.5 0 0 1-1.093-1.093c-.272-.535-.272-1.235-.272-2.635v-3.5m10.833-4.167-3.333-3.333m0 0L6.758 5.919m3.334-3.333v10"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.667}
      />
    </svg>
  )
}

export function AIGenerateIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height={21} viewBox="0 0 21 21" width={21} xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#a)">
        <path
          d="M15.51 6.754V2.587m-10.834 15v-4.166m8.75-8.75h4.167m-15 10.833H6.76M5.51 1.754 4.856 3.06c-.221.443-.332.664-.48.856a2.5 2.5 0 0 1-.453.454c-.192.147-.413.258-.856.48l-1.307.653 1.307.654c.443.22.664.331.856.48a2.5 2.5 0 0 1 .453.453c.148.192.259.413.48.855l.654 1.308.653-1.308c.222-.442.332-.663.48-.855a2.5 2.5 0 0 1 .454-.454c.192-.148.413-.258.855-.48l1.308-.653-1.308-.654c-.442-.221-.663-.332-.855-.48a2.5 2.5 0 0 1-.454-.453c-.148-.192-.258-.413-.48-.856zm8.75 8.333-.793 1.585c-.221.443-.332.664-.48.856a2.5 2.5 0 0 1-.453.454c-.192.147-.413.258-.856.48l-1.585.792 1.585.793c.443.22.664.331.856.48q.255.197.454.453c.147.192.258.413.48.855l.792 1.586.792-1.586c.222-.442.332-.663.48-.855q.198-.256.454-.454c.191-.148.413-.258.855-.48l1.585-.792-1.585-.793c-.442-.22-.664-.332-.855-.48a2.5 2.5 0 0 1-.454-.453c-.148-.192-.258-.413-.48-.856z"
          stroke="url(#b)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.667}
        />
      </g>
      <defs>
        <linearGradient gradientUnits="userSpaceOnUse" id="b" x1={1.76} x2={18.426} y1={18.421} y2={1.754}>
          <stop stopColor="#FF6C6C" />
          <stop offset={1} stopColor="#DD7BFF" />
        </linearGradient>
        <clipPath id="a">
          <path d="M.093.086h20v20h-20z" fill="#fff" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function PaletteIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M2 12C2 17.5228 6.47715 22 12 22C13.6569 22 15 20.6569 15 19V18.5C15 18.0356 15 17.8034 15.0257 17.6084C15.2029 16.2622 16.2622 15.2029 17.6084 15.0257C17.8034 15 18.0356 15 18.5 15H19C20.6569 15 22 13.6569 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z"
        stroke="#344054"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M7 13C7.55228 13 8 12.5523 8 12C8 11.4477 7.55228 11 7 11C6.44772 11 6 11.4477 6 12C6 12.5523 6.44772 13 7 13Z"
        stroke="#344054"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M16 9C16.5523 9 17 8.55228 17 8C17 7.44772 16.5523 7 16 7C15.4477 7 15 7.44772 15 8C15 8.55228 15.4477 9 16 9Z"
        stroke="#344054"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M10 8C10.5523 8 11 7.55228 11 7C11 6.44772 10.5523 6 10 6C9.44772 6 9 6.44772 9 7C9 7.55228 9.44772 8 10 8Z"
        stroke="#344054"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

export function StarIcon(props: SVGProps<SVGSVGElement>) {
  const color = props.color ?? '#F79009'

  return (
    <svg fill="none" height="9" viewBox="0 0 9 9" width="9" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_2897_1168)">
        <path
          d="M3.93726 1.94974C4.01583 1.79056 4.05512 1.71097 4.10846 1.68554C4.15486 1.66341 4.20877 1.66341 4.25518 1.68554C4.30851 1.71097 4.3478 1.79056 4.42637 1.94974L5.17183 3.45996C5.19503 3.50696 5.20663 3.53045 5.22358 3.5487C5.23858 3.56485 5.25658 3.57794 5.27658 3.58723C5.29916 3.59774 5.32509 3.60153 5.37694 3.6091L7.04442 3.85283C7.22001 3.8785 7.30781 3.89133 7.34844 3.93422C7.38379 3.97153 7.40042 4.02281 7.39369 4.07376C7.38595 4.13233 7.32239 4.19424 7.19527 4.31806L5.98912 5.49285C5.95152 5.52947 5.93272 5.54778 5.92059 5.56957C5.90985 5.58886 5.90296 5.61005 5.9003 5.63197C5.8973 5.65672 5.90174 5.68259 5.91061 5.73432L6.19521 7.39365C6.22522 7.56867 6.24023 7.65617 6.21202 7.7081C6.18748 7.75328 6.14386 7.78497 6.09331 7.79434C6.0352 7.80511 5.95662 7.76379 5.79946 7.68114L4.30876 6.89719C4.26231 6.87277 4.23909 6.86055 4.21462 6.85576C4.19296 6.85151 4.17067 6.85151 4.14901 6.85576C4.12454 6.86055 4.10132 6.87277 4.05487 6.89719L2.56417 7.68114C2.40701 7.76379 2.32843 7.80511 2.27032 7.79434C2.21977 7.78497 2.17615 7.75328 2.15161 7.7081C2.1234 7.65617 2.13841 7.56867 2.16843 7.39365L2.45302 5.73432C2.46189 5.68259 2.46633 5.65672 2.46333 5.63197C2.46067 5.61005 2.45378 5.58886 2.44304 5.56957C2.43091 5.54778 2.41211 5.52947 2.37451 5.49285L1.16836 4.31806C1.04124 4.19424 0.977678 4.13233 0.969944 4.07376C0.963214 4.02281 0.979839 3.97153 1.01519 3.93422C1.05582 3.89133 1.14362 3.8785 1.31921 3.85283L2.98669 3.6091C3.03855 3.60153 3.06447 3.59774 3.08705 3.58723C3.10705 3.57794 3.12505 3.56485 3.14005 3.5487C3.15701 3.53045 3.1686 3.50696 3.1918 3.45996L3.93726 1.94974Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.02273"
        />
      </g>
      <defs>
        <clipPath id="clip0_2897_1168">
          <rect fill="white" height="8.18182" transform="translate(0.0909119 0.772461)" width="8.18182" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function SettingsIconContainer({ children }: { children: React.ReactNode }) {
  return (
    <Box
      sx={{
        width: '32px',
        height: '32px',
        borderRadius: '12px',
        border: '1px solid #EAECF0',
        boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        '&:hover': {
          bgcolor: '#F8F9FC',
        },
      }}
    >
      {children}
    </Box>
  )
}

export function RulerIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M9.50399 4.08777L10.4068 4.99055M7.69844 5.89333L8.60122 6.7961M5.89288 7.69888L6.79566 8.60166M4.08733 9.50444L4.99011 10.4072M2.32128 11.3495L4.64962 13.6779C4.76879 13.7971 4.82838 13.8566 4.89709 13.879C4.95753 13.8986 5.02263 13.8986 5.08307 13.879C5.15178 13.8566 5.21137 13.7971 5.33054 13.6779L13.6774 5.33103C13.7966 5.21186 13.8562 5.15227 13.8785 5.08356C13.8981 5.02312 13.8981 4.95802 13.8785 4.89758C13.8562 4.82887 13.7966 4.76928 13.6774 4.65011L11.3491 2.32177C11.2299 2.2026 11.1703 2.14301 11.1016 2.12069C11.0412 2.10105 10.976 2.10105 10.9156 2.12069C10.8469 2.14301 10.7873 2.2026 10.6681 2.32177L2.32128 10.6686C2.20211 10.7878 2.14252 10.8474 2.1202 10.9161C2.10056 10.9765 2.10056 11.0416 2.1202 11.1021C2.14252 11.1708 2.20211 11.2304 2.32128 11.3495Z"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2037"
      />
    </svg>
  )
}
